import { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import PersonalVerification from './pages/PersonalVerification';
import LegalPersonVerification from './pages/LegalPersonVerification';
import RegisteredLegalPerson from './pages/RegisteredLegalPerson';
import Layout from './pages/Layout';
import LegalPersonReferenceAdd from './pages/LegalPersonReferenceAdd';
import LegalPersonReference from './pages/LegalPersonReference';
import Customer from './pages/Customer';
import LegalPersonalEntryForm from './pages/legalPersonalEntryForm/LegalPersonalEntryForm';
import LegalPersonalEntryFormConfirm from './pages/legalPersonalEntryForm/LegalPersonalEntryFormConfirm';
import LegalPersonalEntryFormGuide from './pages/legalPersonalEntryForm/LegalPersonalEntryFormGuide';
import LegalPersonalEntryFormEKYC from './pages/legalPersonalEntryForm/LegalPersonalEntryFormEKYC';
import LegalPersonalEntryFormComplete  from './pages/legalPersonalEntryForm/LegalPersonalEntryFormComplete';
import PersonalEntryForm from './pages/personalEntryForm/PersonalEntryForm';
import PersonalEntryFormConfirm from './pages/personalEntryForm/PersonalEntryFormConfirm';
import PersonalEntryFormGuide from './pages/personalEntryForm/PersonalEntryFormGuide';
import PersonalEntryFormComplete from './pages/personalEntryForm/PersonalEntryFormComplete';
import PersonalEntryFormReturnToOriginalTab from './pages/personalEntryForm/PersonalEntryFormReturnToOriginalTab';
import IpRestrictionChecker from './components/IpRestrictionChecker';
// import AuthPersistence from './components/auth/AuthPersistence';

function PublicRoute() {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const location = useLocation();
  const isPageReload = sessionStorage.getItem('isAuthenticated') === 'true';
  const lastPath = sessionStorage.getItem('lastPath');
  
  console.log('PublicRoute: isAuthenticated =', isAuthenticated);
  console.log('PublicRoute: Current path =', location.pathname);
  console.log('PublicRoute: isPageReload =', isPageReload);
  console.log('PublicRoute: lastPath =', lastPath);
  
  // If this is a page reload and we were previously authenticated, redirect to the last path
  if (isPageReload && lastPath && lastPath !== '/login') {
    console.log('PublicRoute: Page reload detected, redirecting to last path:', lastPath);
    return <Navigate to={lastPath} replace />;
  }
  
  // Normal authentication check
  if (!isAuthenticated) {
    console.log('PublicRoute: User is not authenticated, allowing access');
    return <Outlet />;
  }
  
  console.log('PublicRoute: User is authenticated, redirecting to dashboard');
  return <Navigate to="/dashboard" />;
}

function PrivateRoute() {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const location = useLocation();
  const isPageReload = sessionStorage.getItem('isAuthenticated') === 'true';
  
  console.log('PrivateRoute: isAuthenticated =', isAuthenticated);
  console.log('PrivateRoute: Current path =', location.pathname);
  console.log('PrivateRoute: isPageReload =', isPageReload);
  
  // If this is a page reload and we were previously authenticated, allow access
  if (isPageReload && location.pathname !== '/login') {
    console.log('PrivateRoute: Page reload detected, allowing access');
    return <Outlet />;
  }
  
  // Normal authentication check
  if (isAuthenticated) {
    console.log('PrivateRoute: User is authenticated, allowing access');
    sessionStorage.setItem('isAuthenticated', 'true');
    return <Outlet />;
  }
  
  console.log('PrivateRoute: User is not authenticated, redirecting to login');
  return <Navigate to="/login" />;
}

function App() {
  return (
    <Suspense fallback={null}>
      <IpRestrictionChecker>
        <Router>
          {/* <AuthPersistence /> */}
          <Routes>
            {/* /form パスは IP制限なしでアクセス可能 */}
            <Route path="/form/legalPersonal" element={<LegalPersonalEntryForm />} />
            <Route path="/form/legalPersonal/confirm" element={<LegalPersonalEntryFormConfirm />} />
            <Route path="/form/legalPersonal/guide" element={<LegalPersonalEntryFormGuide />} />
            <Route path="/form/legalPersonal/ekyc" element={<LegalPersonalEntryFormEKYC />} />
            <Route path="/form/legalPersonal/complete" element={<LegalPersonalEntryFormComplete />} />
            <Route path="/form/personal" element={<PersonalEntryForm />} />
            <Route path="/form/personal/confirm" element={<PersonalEntryFormConfirm />} />
            <Route path="/form/personal/guide" element={<PersonalEntryFormGuide />} />
            <Route path="/form/personal/complete" element={<PersonalEntryFormComplete />} />
            <Route path="/form/personal/returnToOriginalTab" element={<PersonalEntryFormReturnToOriginalTab />} />

            {/* PublicRoute: ログインしていないユーザー向けのルート */}
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Route>

            {/* PrivateRoute: ログインしたユーザー向けのルート */}
            <Route element={<PrivateRoute />}>
              <Route path="" element={<Layout />}>  
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/personal-inbound-list" element={<PersonalVerification />} />
                <Route path="/corporate-inbound-list" element={<LegalPersonVerification />} />
                <Route path="/corporate-reference" element={<LegalPersonReferenceAdd />} />
                <Route path="/corporate-reference-list" element={<LegalPersonReference />} />
                <Route path="/corporate-registration-list" element={<RegisteredLegalPerson />} />
                <Route path="/users" element={<Users />} />
                <Route path="/customer" element={<Customer />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </IpRestrictionChecker>
    </Suspense>
  );
}

export default App;
